<div class="setup-container h-full bg-[#7CAFE4]">
  <div class="container absolute mt-3 flex items-center justify-between px-10">
    <img
      class="h-[48px] w-[48px] cursor-pointer items-center text-primary-blue"
      src="assets/images/logo-header-white.svg"
      width="48"
      height="48"
      (click)="onLogoClick()"
    />
  </div>
  <div class="flex h-full justify-center">
    <div class="self-center rounded-[48px] bg-background-white px-[17px] pb-3 pt-11 shadow-card" [ngClass]="modalClass()">
      <div class="h-full overflow-y-auto px-[27px]">
        <div class="pb-8">
          @if (vmSignal().contract?.state === DataState.Loading) {
            <div class="flex h-full items-center justify-center">
              <ng-lottie currentColor class="text-text-blue" [options]="lottieOptions"></ng-lottie>
            </div>
          } @else {
            <router-outlet></router-outlet>
          }
        </div>
      </div>
    </div>
  </div>
</div>
